import { Clear } from "@mui/icons-material"
import { Box, IconButton, Menu, Stack, TextField, Typography } from "@mui/material"
import { observer } from "mobx-react-lite"
import { ChangeEvent, FC } from "react"
import { useMenu } from "../../../../app/hook/useMenu"
import { IHomeTableFilterSession } from "../../../../app/stores/homeTableEquipmentStore"
import { HomeFilterButton } from "../../common/HomeFilterButton"

interface Props {
    handleChange: (column: IHomeTableFilterSession, value: string) => void
    session: IHomeTableFilterSession
    value: string
    handleClear: (column: IHomeTableFilterSession) => void
}

const SearchFilter: FC<Props> = ({ session, handleChange, value, handleClear }) => {
    const { anchorEl, isOpen, handleClose, handleOpen, stopPropagation } = useMenu()
    
    const onChange = (e: ChangeEvent<HTMLInputElement>) => 
        handleChange(session, e.currentTarget.value)

    const onClear = () => {
        handleClear(session)
        handleClose()
    }
    
    return (
        <>
            <HomeFilterButton onClick={handleOpen} color={value[0]?.length > 0 ? 'success' : 'default'} />
            <Menu open={isOpen} onClose={handleClose} anchorEl={anchorEl}>
                <Box sx={{px: 2, py: 1, width: '250px'}}>
                    <Typography mb={1}>Show the row that have value</Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <TextField 
                            autoFocus
                            onChange={onChange} 
                            fullWidth 
                            value={value}
                            placeholder="Search" 
                            size="small" 
                            label={
                                (session === 'tagNumber' && 'Tag Number') 
                                || (session === 'systemName' && 'System Name')
                            }
                            onKeyDown={stopPropagation} 
                        />
                        <IconButton size="small" onClick={onClear} sx={{flexShrink: 1}}>
                            <Clear fontSize="small" />
                        </IconButton>
                    </Stack>
                </Box>
            </Menu>
        </>
    )
}

export default observer(SearchFilter)